import { Routes, Route, Navigate, useLocation } from 'react-router';
import { useEffect, lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { initGA, trackPageView } from './services/analytics';
import { ModalProvider } from './providers/ModalProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import Layout from './Layout';
import Home from './pages/Home';
import { AuthProvider } from './providers/AuthProvider';
import ModalManager from './components/ModalManager';

// Lazy load pages that aren't needed immediately
const RecipesByTagView = lazy(() => import('./pages/RecipesByTag/recipesByTag/view').then(m => ({ default: m.RecipesByTagView })));
const RecipesView = lazy(() => import('./pages/Recipes/recipes/view').then(m => ({ default: m.RecipesView })));
const RecipeView = lazy(() => import('./pages/Recipe/view').then(m => ({ default: m.RecipeView })));
const UserProfileView = lazy(() => import('./pages/UserProfile/view').then(m => ({ default: m.UserProfileView })));
const FavoriteRecipesView = lazy(() => import('./pages/favorites/view'));
const AdminPage = lazy(() => import('./pages/Admin'));

// Loading fallback component
function PageLoader() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

function App() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <AuthProvider>
      <ThemeProvider>
        <ModalProvider>
          <ModalManager />
          <Layout>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<Home />} />
                <Route path="/recipes" element={<RecipesView />} />
                <Route path="/recipe/:documentId" element={<RecipeView />} />
                <Route path="/recipeTag/:tagName" element={<RecipesByTagView />} />
                <Route path="/me" element={<UserProfileView />} />
                <Route path="/myFavorites" element={<FavoriteRecipesView />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Suspense>
          </Layout>
        </ModalProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
